// Pure track-state / teardown-race guards for the media client (modules/04 §6).
//
// mediasoup-client `transport.produce()` throws `InvalidStateError: track ended` when the
// supplied MediaStreamTrack.readyState is already "ended". That happens if stop() tears the
// call down (stopping local tracks) while start()'s getUserMedia/getDisplayMedia is still in
// flight. These helpers let the client decide, deterministically, whether it is still safe
// to publish a track — and are unit-tested without a live device.

/** True only when the track exists and is still live (not ended). */
export function isTrackLive(track: MediaStreamTrack | null | undefined): boolean {
  return !!track && track.readyState === "live";
}

/** Safe to call transport.produce() only when the client is open and the track is live. */
export function canProduceTrack(closed: boolean, track: MediaStreamTrack | null | undefined): boolean {
  return !closed && isTrackLive(track);
}
